import styled from 'styled-components';
import { Input } from 'antd';

export const SearchInput = styled(Input.Search)``;
